import { render, staticRenderFns } from "./APVList.vue?vue&type=template&id=00f98777&scoped=true&"
import script from "./APVList.vue?vue&type=script&lang=js&"
export * from "./APVList.vue?vue&type=script&lang=js&"
import style0 from "./APVList.vue?vue&type=style&index=0&id=00f98777&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f98777",
  null
  
)

export default component.exports